import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import NProgress from 'nprogress'
import './directive/index';
import './prototype/index'
import './scss/index.scss';
import './assets/iconfont/iconfont.css';
import './assets/svgIcon/index';
import './scss/common.scss'
import elementUI from './utils/element';
import login from "@/api/modules/login";
import {getToken, setToken} from "@/utils/auth";
import vueAwesomeSwiper from 'vue-awesome-swiper'
import vueFullPage from 'vue-fullpage.js'
import VueCropper from 'vue-cropper'
import {$checkNetwork} from "@/views/NoteboolAI/js/messageThunk";
// import speechRecognition from './views/BuildingAI/components/SpeechRecognition/speechRecognition';

// import '../public/static/capolDMA/capolDMA.css'


Vue.use(vueAwesomeSwiper)
Vue.use(vueFullPage)
Vue.use(elementUI);
Vue.use(NProgress);
Vue.use(VueCropper);
// Vue.use(speechRecognition);
Vue.config.productionTip = false;
Vue.config.ignoredElements.push('wx-open-launch-weapp');
router.afterEach((to, from, next) => {
    NProgress.done();
});
const loginFn = ()=>{
    return new Promise((resolve, reject) => {
        if(getToken()) {resolve(); return}
        login.login({
            username: 'fileuser ',
            password: '123456'
        }).then(res => {
            console.log(res);
            let token = res.data.accessToken;
            setToken(token)
            resolve()
        });
    })

}
const whiteList = ['AIBus', 'mb-pdf']
router.beforeEach(async (to, from, next) => {
    console.log(to.path)
    document.title = to.meta.title || '图模空间-工程数据智能管理平台-图纸识别-图模联动-智能图档-智能叠图-图模比对-智能问答-华阳城科'
    if(!sessionStorage.getItem('checkNetworkBool')){
        await $checkNetwork()
    }
    if(getToken() || to.name === 'homePage' || whiteList.includes(to.name)){
        if(to.path === '/tempFile'){
            next({
                name: 'file'
            })
        }else if(to.path === '/note'){
            //
            if(sessionStorage.getItem('checkNetworkBool') === 'true'){
                next()
            }else{
                await $checkNetwork()
                if(sessionStorage.getItem('checkNetworkBool') === 'true'){
                    next()
                }else{
                    next({
                        name: 'homePage'
                    });
                }
            }
        }else{
            next()
        }
    }else{
        next({
            name: 'homePage'
        });
    }
});
new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount('#app');
